<div class="star-rating">
  <div class="average-rating-container" [style.width.px]="26 * maxCount">
    <ul class="rating foreground readonly" [style.width.%]="filledInStarsContainerWidth">
      <li *ngFor="let star of ratingArray" class="star filled" [ngClass]="{'disabled': star.disabled}">
        <i class="material-icons">
          <ng-container *ngIf="star.empty">
            star_border
          </ng-container>
          <ng-container *ngIf="!star.empty">
            star
          </ng-container>
        </i>
      </li>
    </ul>
  </div>
</div>
